import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=110a3341&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=110a3341&prod&lang=css"
import style1 from "./serviceList.vue?vue&type=style&index=1&id=110a3341&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a3341",
  null
  
)

export default component.exports